class AccountSettings.HashtagBySourceCollectionUrlProvider extends Backbone.Model
  baseUrl: '/keepcon/hashtag_searches_collection'

  initialize:(source)->
    @source = source

  url:(page)->
    @baseUrl + '/' + @source + '/' + page
